import { GameType } from '@/models/games/enums/GameType';
import { FishPrawnCrabResult } from '@/models/games/fishprawncrab';
import { TableMode } from '@/models/TableMode';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import { SupportedGame } from '@/modules/host/models';
import { hostsSliceActions } from '@/modules/host/slice';
import { SupportedGameLiveData } from '@/modules/hostLive/models';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { getMainUserState } from '@/modules/main/selector';
import store from '@/store/store';
import { getIsRestState } from '@/utils/commonFunc';
import {
    convertResultToRecord,
    getResultForFResult,
} from '@/utils/games/fishprawncrab';
import { Dispatch } from 'react';
import { batch } from 'react-redux';
import { AnyAction } from 'redux';
import { CMDScInitFishprawncrab, ICommand } from '../live';
import { CMDFishprawncrab } from '../live/CMDFishprawncrab';
import { AbstractHandler } from './AbstractHandler';

export class CMDScInitFishPrawnCrabHandler extends AbstractHandler {
    _command: CMDScInitFishprawncrab;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScInitFishprawncrab;
    }

    override convertResult(result: CMDFishprawncrab): FishPrawnCrabResult {
        const newResult = Object.assign(
            this.convertBaseResult(result.BaseResult),
            {
                Dice1: result.Detail.Dice1,
                Dice2: result.Detail.Dice2,
                Dice3: result.Detail.Dice3,
            },
            getResultForFResult(result.BaseResult.FResult)
        ) as FishPrawnCrabResult;
        return newResult;
    }

    override handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const { IsInternalTest } = getMainUserState(state);
        const game = {} as SupportedGame;
        const info = this.convertInformation(this._command.Information);
        const hostId = info.HostId;
        const liveData = {} as SupportedGameLiveData;
        liveData.GameType = GameType.FishPrawnCrab;
        liveData.CurrentState = this._command.CurrentState;
        liveData.CurrentResult = this.convertResult(
            this._command.CurrentResult
        );
        game.OldResult = this._command.OldResult.filter(o => {
            if ((o as CMDFishprawncrab).BaseResult.Result === 0) return false;
            return true;
        }).map(o => this.convertResult(o));
        game.OldResult = game.OldResult.filter(
            (arr, index, self) =>
                index === self.findIndex(t => t.GameID === arr.GameID)
        );
        liveData.ResultReleased = false;
        const restMode = getIsRestState(
            this._command.Information.Rest,
            IsInternalTest
        );
        game.IsRest = restMode.isRest;
        game.IsPause = restMode.isPause;
        game.IsInternalTest =
            IsInternalTest &&
            this._command.Information.Rest == TableMode.InternalTest;
        const convertedRecord = game.OldResult.map(r =>
            convertResultToRecord(r as FishPrawnCrabResult)
        );
        batch(() => {
            dispatch(
                tableBetSliceActions.initTable({
                    hostId: hostId,
                    gameId: this._command.CurrentResult.BaseResult.GameID,
                })
            );
            dispatch(hostLiveSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostLiveSliceActions.updateInformation(info));
            dispatch(hostsSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostsSliceActions.updateInformation(info));
            dispatch(
                hostsSliceActions.updateRecord({
                    hostId,
                    record:
                        convertedRecord.length > 50
                            ? convertedRecord.splice(
                                  convertedRecord.length - 50
                              )
                            : convertedRecord,
                })
            );
        });
    }
}
